module.exports = __webpack_public_path__ + "static/media/EMC-speaker.ebbd7573.jpg";